import React from 'react';
import Dashboard from '../dashboard/Dashboard';
import Artists from '../artists/Artists';
import Artist from '../artists/Artist';
import Users from '../users/Users';
import User from '../users/User';
import Collections from '../collections/Collections';
import Collection from '../collections/Collection';
import PrintObject from '../print-object/PrintObject';
import PrintObjects from '../print-object/PrintObjects';
import UserPermissions from '../users/users_permissions';
import Settings from '../settings/Settings';
import UserRoles from '../roles/UserRoles';
import NegMenu from '../object/Neg';
import Reports from '../reports/Reports';
import Bibliography from '../bibliography';
import MovableWork from '../portfolio/MovableWork';
import MovableWorkList from '../portfolio/MovableWorkList';
import { EmployeesIcon, SettingIcon } from './icons';
import {
  HomeOutlined,
  PrinterOutlined,
  LockOutlined,
  ProfileOutlined,
  InsertRowBelowOutlined,
  UserSwitchOutlined,
  CalendarOutlined,
  GoldOutlined,
  EnvironmentOutlined,
  SnippetsOutlined,
  PictureOutlined,
  FileImageOutlined,
  AuditOutlined,
  DatabaseOutlined,
  BookOutlined,
  HistoryOutlined,
  ReconciliationOutlined,
  FileTextOutlined,
  OrderedListOutlined,
  ReadOutlined,
  SettingOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined,
  AlignLeftOutlined,
  BuildOutlined,
  AppstoreOutlined,
  TableOutlined,
  BorderOuterOutlined,
  PushpinOutlined,
  GlobalOutlined,
  FlagOutlined,
  ClusterOutlined,
  ToolOutlined,
  TrademarkCircleOutlined,
  EditOutlined,
  HighlightOutlined,
  BulbOutlined,
  BorderInnerOutlined,
  ExperimentOutlined,
  FormOutlined,
  BarChartOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';

const admin = [
  {
    name: 'Dashboard',
    key: 'dashboard',
    icon: <HomeOutlined className={'sidebar-icon'} />,
    component: props => <Dashboard {...props} />,
  },
  {
    name: 'Users',
    key: 'users',
    icon: <EmployeesIcon className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? (
        <User {...props} />
      ) : section === 'manage-permissions' ? (
        <UserPermissions {...props} />
      ) : (
        <Users {...props} />
      );
    },
  },
  {
    name: 'Roles',
    key: 'roles',
    icon: <SafetyCertificateOutlined className={'sidebar-icon'} />,
    component: props => <UserRoles {...props} />,
  },

  {
    name: 'Artists',
    key: 'artists',
    icon: <UserSwitchOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <Artist {...props} /> : <Artists {...props} />;
    },
  },
  {
    name: 'Collections',
    key: 'collections',
    icon: <AppstoreOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <Collection {...props} /> : <Collections {...props} />;
    },
  },
  {
    name: 'Portfolio Movable Work',
    key: 'portfolio-movable-work',
    icon: <SnippetsOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <MovableWork {...props} /> : <MovableWorkList {...props} />;
    },
  },
  {
    name: 'Negatives',
    key: 'negatives',
    icon: <PictureOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <NegMenu {...props} />;
    },
    children: [
      {
        label: 'Negative Objects',
        key: 'negative-objects',
        icon: <PictureOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Requests',
        key: 'negative-req',
        icon: <ReconciliationOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative History',
        key: 'negative-history',
        icon: <HistoryOutlined className={'sidebar-icon'} />,
      },
    ],
  },
  {
    name: 'Print Objects',
    key: 'print-objects',
    icon: <FileImageOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      if (section === 'new' || section === 'collection' || section === 'edit') {
        return <PrintObject {...props} />;
      }
      return <PrintObjects {...props} />;
    },
  },
  // {
  //   name: 'Reports',
  //   key: 'reports',
  //   icon: <FileTextOutlined className={'sidebar-icon'} />,
  //   component: (props, section = '') => {
  //     return <Reports {...props} />;
  //   },
  //   children: [
  //     {
  //       label: 'Cataloging Report',
  //       key: 'cataloging-report',
  //       icon: <OrderedListOutlined className={'sidebar-icon'} />,
  //       // component: (props, section = '') => {
  //       //   return <BasicReports {...props} />;
  //       // },
  //       children: [
  //         {
  //           label: 'Basic Prints Report',
  //           key: 'basic-print',
  //           icon: <PrinterOutlined className={'sidebar-icon'} />,
  //         },
  //         {
  //           label: 'Catalog Report',
  //           key: 'catalog-report',
  //           icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //         },
  //         {
  //           label: 'Naming Convention Report',
  //           key: 'naming-convention-report',
  //           icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Data Reports',
  //       key: 'data-reports',
  //       icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //     },
  //     // {
  //     //   label: 'Locations',
  //     //   key: 'locations',
  //     //   icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //     // },
  //     {
  //       label: 'Reading Reports',
  //       key: 'reading-reports',
  //       icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //       children: [
  //         {
  //           label: 'Category Reports',
  //           key: 'category-reports',
  //           icon: <ProfileOutlined className={'sidebar-icon'} />,
  //         },
  //         {
  //           label: 'Locations',
  //           key: 'locations',
  //           icon: <EnvironmentOutlined className={'sidebar-icon'} />,
  //         },
  //       ],
  //     },
  //     {
  //       label: 'Report History',
  //       key: 'report-history',
  //       icon: <ProfileOutlined className={'sidebar-icon'} />,
  //     },
  //   ],
  // },
  {
    name: 'Reports',
    key: 'reports',
    icon: <FileTextOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Reports {...props} />;
    },
    children: [
      {
        label: 'Analytical Report',
        key: 'analytical-report',
        icon: <ProfileOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Data Report',
            key: 'data-report',
            icon: <ProfileOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Report',
            key: 'image-report',
            icon: <FileImageOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Cataloging Report',
        key: 'cataloging-report',
        icon: <OrderedListOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Basic Prints Report',
            key: 'basic-print',
            icon: <PrinterOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Catalog Report',
            key: 'catalog-report',
            icon: <AppstoreOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Naming Convention Report',
            key: 'naming-convention-report',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Data Reports',
        key: 'data-reports',
        icon: <DatabaseOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Reading Reports',
        key: 'reading-reports',
        icon: <BookOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Category Reports',
            key: 'category-reports',
            icon: <ProfileOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Locations',
            key: 'locations',
            icon: <EnvironmentOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Object Report',
        key: 'report-by-object',
        icon: <FileDoneOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Report',
        key: 'report-by-negative',
        icon: <FileImageOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Report History',
        key: 'report-history',
        icon: <HistoryOutlined className={'sidebar-icon'} />,
      },

      {
        label: 'Bibliography Report',
        key: 'bibliography-report',
        icon: <OrderedListOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Plate Inventory per Book',
            key: 'plate-inventory',
            icon: <PrinterOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Publication List',
            key: 'image-pub-list',
            icon: <AppstoreOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Publication List with Variants',
            key: 'pub-list-with-variants',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Bibliography',
            key: 'biblio-rpt',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Published Images',
            key: 'published-images',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
        ],
      },
    ],
  },
  {
    name: 'Bibliography',
    key: 'bibliography',
    icon: <BookOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Bibliography {...props} />;
    },
    children: [
      {
        label: 'Books',
        key: 'books',
        icon: <ReadOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Book Illustrations',
        key: 'book-illustrations',
        icon: <PictureOutlined className={'sidebar-icon'} />,
      },
    ],
  },
  {
    name: 'Settings',
    key: 'settings',
    icon: <SettingOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Settings {...props} />;
    },
    children: [
      {
        label: 'Prints Conditions',
        key: 'prints-conditions',
        icon: <FileProtectOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Authenticity',
        key: 'authenticity',
        icon: <SafetyCertificateOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Conditions',
        key: 'mount-conditions',
        icon: <AlignLeftOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Condition Type',
        key: 'mount-condition-type',
        icon: <BuildOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Types',
        key: 'mount-types',
        icon: <AppstoreOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Date Confidence',
        key: 'date-confidence',
        icon: <CalendarOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Support Table',
        key: 'support-table',
        icon: <TableOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Sheet Dimensions',
        key: 'negative-sheet-dimensions',
        icon: <BorderOuterOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Image Description',
        key: 'image-description',
        icon: <FileImageOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Object Locations',
        key: 'object-locations',
        icon: <PushpinOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Geographic Locations',
        key: 'geographic-locations',
        icon: <GlobalOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'States',
        key: 'states',
        icon: <FlagOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Parks',
        key: 'parks',
        icon: <ClusterOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Configuration',
        key: 'configuration',
        icon: <ToolOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Stamps',
        key: 'stamps',
        icon: <TrademarkCircleOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Signatures',
        key: 'signatures',
        icon: <EditOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Annotation Materials',
        key: 'annotation-materials',
        icon: <HighlightOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Portfolio Conceptual Work',
        key: 'portfolio-conceptual-works',
        icon: <BulbOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Signature Read Placement',
        key: 'signature-placement',
        icon: <BorderInnerOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Dmin Sample Area',
        key: 'dmin-sample',
        icon: <ExperimentOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Handwriting',
        key: 'hand-writing',
        icon: <FormOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Groups',
        key: 'paper-groups',
        icon: <ReconciliationOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Family',
        key: 'paper-family',
        icon: <FileTextOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Group Stats',
        key: 'paper-group-stats',
        icon: <BarChartOutlined className={'sidebar-icon'} />,
      },
    ],
  },
];

const other_users = [
  {
    name: 'Dashboard',
    key: 'dashboard',
    icon: <HomeOutlined className={'sidebar-icon'} />,
    component: props => <Dashboard {...props} />,
  },
  {
    name: 'Artists',
    key: 'artists',
    icon: <UserSwitchOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <Artist {...props} /> : <Artists {...props} />;
    },
  },
  {
    name: 'Collections',
    key: 'collections',
    icon: <AppstoreOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <Collection {...props} /> : <Collections {...props} />;
    },
  },
  {
    name: 'Portfolio Movable Work',
    key: 'portfolio-movable-work',
    icon: <SnippetsOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return section == 'new' || section == 'edit' ? <MovableWork {...props} /> : <MovableWorkList {...props} />;
    },
  },
  {
    name: 'Negatives',
    key: 'negatives',
    icon: <PictureOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <NegMenu {...props} />;
    },
    children: [
      {
        label: 'Negative Objects',
        key: 'negative-objects',
        icon: <PictureOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Requests',
        key: 'negative-req',
        icon: <ReconciliationOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative History',
        key: 'negative-history',
        icon: <HistoryOutlined className={'sidebar-icon'} />,
      },
    ],
  },
  {
    name: 'Print Objects',
    key: 'print-objects',
    icon: <FileImageOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      if (section === 'new' || section === 'collection' || section === 'edit') {
        return <PrintObject {...props} />;
      }
      return <PrintObjects {...props} />;
    },
  },
  {
    name: 'Reports',
    key: 'reports',
    icon: <FileTextOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Reports {...props} />;
    },
    children: [
      {
        label: 'Analytical Report',
        key: 'analytical-report',
        icon: <ProfileOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Data Report',
            key: 'data-report',
            icon: <ProfileOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Report',
            key: 'image-report',
            icon: <FileImageOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Cataloging Report',
        key: 'cataloging-report',
        icon: <OrderedListOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Basic Prints Report',
            key: 'basic-print',
            icon: <PrinterOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Catalog Report',
            key: 'catalog-report',
            icon: <AppstoreOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Naming Convention Report',
            key: 'naming-convention-report',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Data Reports',
        key: 'data-reports',
        icon: <DatabaseOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Reading Reports',
        key: 'reading-reports',
        icon: <BookOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Category Reports',
            key: 'category-reports',
            icon: <ProfileOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Locations',
            key: 'locations',
            icon: <EnvironmentOutlined className={'sidebar-icon'} />,
          },
        ],
      },
      {
        label: 'Object Report',
        key: 'report-by-object',
        icon: <FileDoneOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Report',
        key: 'report-by-negative',
        icon: <FileImageOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Report History',
        key: 'report-history',
        icon: <HistoryOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Bibliography Report',
        key: 'bibliography-report',
        icon: <OrderedListOutlined className={'sidebar-icon'} />,
        children: [
          {
            label: 'Plate Inventory per Book',
            key: 'plate-inventory',
            icon: <PrinterOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Publication List',
            key: 'image-pub-list',
            icon: <AppstoreOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Image Publication List with Variants',
            key: 'pub-list-with-variants',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Bibliography',
            key: 'biblio-rpt',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
          {
            label: 'Published Images',
            key: 'published-images',
            icon: <AuditOutlined className={'sidebar-icon'} />,
          },
        ],
      },
    ],
  },
  {
    name: 'Bibliography',
    key: 'bibliography',
    icon: <BookOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Bibliography {...props} />;
    },
    children: [
      {
        label: 'Books',
        key: 'books',
        icon: <ReadOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Book Illustrations',
        key: 'book-illustrations',
        icon: <PictureOutlined className={'sidebar-icon'} />,
      },
    ],
  },
  {
    name: 'Settings',
    key: 'settings',
    icon: <SettingOutlined className={'sidebar-icon'} />,
    component: (props, section = '') => {
      return <Settings {...props} />;
    },
    children: [
      {
        label: 'Prints Conditions',
        key: 'prints-conditions',
        icon: <FileProtectOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Authenticity',
        key: 'authenticity',
        icon: <SafetyCertificateOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Conditions',
        key: 'mount-conditions',
        icon: <AlignLeftOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Condition Type',
        key: 'mount-condition-type',
        icon: <BuildOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Mount Types',
        key: 'mount-types',
        icon: <AppstoreOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Date Confidence',
        key: 'date-confidence',
        icon: <CalendarOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Support Table',
        key: 'support-table',
        icon: <TableOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Negative Sheet Dimensions',
        key: 'negative-sheet-dimensions',
        icon: <BorderOuterOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Image Description',
        key: 'image-description',
        icon: <FileImageOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Object Locations',
        key: 'object-locations',
        icon: <PushpinOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Geographic Locations',
        key: 'geographic-locations',
        icon: <GlobalOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'States',
        key: 'states',
        icon: <FlagOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Parks',
        key: 'parks',
        icon: <ClusterOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Configuration',
        key: 'configuration',
        icon: <ToolOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Stamps',
        key: 'stamps',
        icon: <TrademarkCircleOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Signatures',
        key: 'signatures',
        icon: <EditOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Annotation Materials',
        key: 'annotation-materials',
        icon: <HighlightOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Portfolio Conceptual Work',
        key: 'portfolio-conceptual-works',
        icon: <BulbOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Signature Read Placement',
        key: 'signature-placement',
        icon: <BorderInnerOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Dmin Sample Area',
        key: 'dmin-sample',
        icon: <ExperimentOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Handwriting',
        key: 'hand-writing',
        icon: <FormOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Groups',
        key: 'paper-groups',
        icon: <ReconciliationOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Family',
        key: 'paper-family',
        icon: <FileTextOutlined className={'sidebar-icon'} />,
      },
      {
        label: 'Paper Group Stats',
        key: 'paper-group-stats',
        icon: <BarChartOutlined className={'sidebar-icon'} />,
      },
    ],
  },
];

export const profileMenu = [
  {
    name: 'Sign Out',
    key: 'sign-out',
  },
];

export const sideMenu = {
  admin,
  other_users,
};
